import dayjs from 'dayjs'

import { JobDashboardPublicationStatus } from 'generated/graphql'

import { JOB_WITH_OWNER_NAME_DATE } from '../consts/jobWithOwnerNameDate'

const TOLGEE_PREFIX = 'getJobUpdatedDate'

export function getJobUpdatedDate(job, t) {
  if (!job) return ''

  const { createdAt, updatedAt, ownerName, publicationStatus } = job

  const shouldRenderOwnerName = dayjs(createdAt).isAfter(dayjs(JOB_WITH_OWNER_NAME_DATE))
  const timeElapsed = dayjs().to(updatedAt)

  const isDraftBriefing = publicationStatus === JobDashboardPublicationStatus.Draft

  if (isDraftBriefing) {
    return t({
      key: `${TOLGEE_PREFIX}-createdByEdited`,
      defaultValue: 'Por {ownerName} · Editado {timeElapsed}',
      parameters: { ownerName, timeElapsed },
    })
  }
  if (shouldRenderOwnerName) {
    return t({
      key: `${TOLGEE_PREFIX}-createdFinished`,
      defaultValue: 'Por {ownerName} · Finalizado {timeElapsed}',
      parameters: { ownerName, timeElapsed },
    })
  }
  return t({
    key: `${TOLGEE_PREFIX}-timeElapsed`,
    defaultValue: 'Editado {timeElapsed}',
    parameters: { timeElapsed },
  })
}
